module.exports = __webpack_public_path__ + "img/pic_new_features_7.ac8ad811.png";